import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import appConfig from '../../consumingApi/services/appConfig';
import LogisticService from '@LogisticService';

const BASE_URL = appConfig.logisticsUrl;
const REDUCER_NAME = 'polygon';
const GET_DELIVERY_AREAS = 'polygon/getDeliveryAreas';

const initialState = {
    areas: [],
    areasStatus: 'idle',
    selectedAreaInfos: null
};

export const getDeliveryAreas = createAsyncThunk(GET_DELIVERY_AREAS, async (_, { rejectWithValue }) => {
    try {
        const res = await LogisticService.requestWithAuth(`${BASE_URL}/atendimento/senninha/areas_delivery`);
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) {
            window.location.href = "/login";
        }
        if (!err.response) {
            throw err;
        }
        return rejectWithValue(err.response.data || err.response);
    }
});

export const polygonsSlice = createSlice({
    name: REDUCER_NAME,
    initialState,
    reducers: {
        setSelectedArea: (state, action) => {
            state.selectedAreaInfos = { ...action.payload.selectedAreaInfos };
        },
        resetAreas: (state) => {
            state.areas = [];
            state.areasStatus = 'idle';
            state.selectedAreaInfos = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDeliveryAreas.pending, (state) => {
                state.areasStatus = 'pending';
            })
            .addCase(getDeliveryAreas.fulfilled, (state, action) => {
                state.areas = action.payload; //{ bounds, id, name }
                state.areasStatus = 'fulfilled';
            })
            .addCase(getDeliveryAreas.rejected, (state) => {
                // state.error = action.payload;
                state.areasStatus = 'rejected';
            });
    },
});

export const {
    setSelectedArea,
    resetAreas,
} = polygonsSlice.actions;

export const polygonSelector = (state) => state.polygonsSlice;

export default polygonsSlice.reducer;
